<template>
    <iv-breadcrumb>
        <iv-breadcrumb-item
            v-for="(item,index) in list"
            :key="index"
            :to="item.to">{{ item.title }}</iv-breadcrumb-item>
    </iv-breadcrumb>
</template>
<script>
import { common } from "@/mixins/common.mixin";
import { getCrumb,findNode } from "@/routes/";

export default {
    mixins: [common],
    props: {
        route: Object
    },
    data(){
        return {
            list: this.refresh(this.route)
        }
    },
    watch: {
        route(val){
            this.list = this.refresh(val);
        }
    },
    methods: {
        refresh(route){
          return getCrumb(route.name).map(node=>{
            return {
              title: node.title,
              ...((node.shown&&node.path)?{to:node.path}:{})
            }
          })
        }
    }
}
</script>
